<template>
  <div class="program-check">
    <subfield>
      <template slot="list">
        <trees :title="$t('crp1')" type="GROUP" @getAssets="getAssets" :list="groupList"></trees>
      </template>
      <template slot="content">
        <enfold-ucd>
          <template slot="up">
            <div class="c-u-left">
              <!-- <i class="icon">
								<img src="@/assets/images/public/public_delete.png" @click="mulDelete"/>
              </i>-->
              <el-button type="primary" @click="checkAll" size="mini" round>{{ $t("review.review") }}</el-button>
              <el-button type="danger" @click="mulDelete" size="mini" round>{{ $t('review.deleteRecord') }}</el-button>
            </div>
            <div class="c-u-right">
              <!-- <el-input v-model="keyword" :placeholder="$t('public.search')" @focus="keyword = undefined">
                <i slot="suffix" class="el-icon-search" @click="keyword && search(keyword)"></i>
              </el-input>  -->
              <div class="select">
                <el-select v-model="select_data" @change="changeSelect" size="mini">
                  <el-option v-for="item in options" :key="item.value" :label="$t(item.label)"
                    :value="item.value"></el-option>
                </el-select>
              </div>
              <div class="search">
                <el-input v-model="keyword" :placeholder="$t('public.search')" @focus="keyword = undefined" size="mini">
                  <i slot="suffix" class="el-icon-search" @click="search(keyword)"></i>
                </el-input>
              </div>
            </div>
          </template>
          <template slot="center">
            <template>
              <el-table ref="multipleTable" :data="programList" :row-key="getRowKey" style="width: 100%" height="100%"
                v-loading="loading" @selection-change="selectionLineChangeHandle">
                <!-- fabu_count > 0则是已经发布的节目或已经关联的节目,无法进行删除 -->
                <!-- <el-table-column type="selection" :selectable="(row)=>row.is_edit === 1" width="50"></el-table-column> -->
                <!-- <el-table-column type="selection" width="50"></el-table-column> -->
                <el-table-column type="selection" :reserve-selection="true" :selectable="(row) => {
                    // return row.play_state == 0;
                    return true;
                  }
                  "></el-table-column>
                <el-table-column :label="$t('review.Screenshot')" width="120">
                  <template slot-scope="scope">
                    <div class="operation">
                      <img style="width: 96px; height: 54px;object-fit: contain;background: #F4F4F5;"
                        v-if="scope.row.damaged === 0" :src="scope.row.pimg" alt />
                      <img style="width: 96px; height: 54px;" v-else src="@imgpub/damaged.png" alt />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="name" :label="$t('review.ProgramName')" show-overflow-tooltip></el-table-column>
                <el-table-column prop="size_remark" :label="$t('review.Resolution')"></el-table-column>
                <el-table-column prop="gn" :label="$t('review.Structure')"></el-table-column>
                <!-- <el-table-column prop="template_name" label="模板名称"></el-table-column> -->
                <el-table-column prop="create_time" :label="$t('review.CreationTime')"></el-table-column>
                <el-table-column :label="$t('review.operate')">
                  <template slot-scope="scope">
                    <!-- <div class="operation"> -->
                      <!-- 未审核状态 -->
                      <div v-if="scope.row.play_state === 0" class="check-btn">
                        <!-- <span style="color: var(--theme-color-customized-1);">{{ $t('review.Review') }}</span> -->
                        <el-button type="success"  @click="programCheck(scope.$index, scope.row)" size="mini" round>{{ $t('review.Review') }}</el-button>
                      </div>
                      <!-- 通过审核 -->
                      <div v-if="scope.row.play_state === 2" >
                        <span style="color: #00c48f">{{ scope.row.check_user.split("&")[0] }}</span>
                        &nbsp;
                        <span>{{ scope.row.check_time.split(" ")[0] }}</span>
                      </div>
                      <!-- 拒绝通过 -->
                      <div v-if="scope.row.play_state === 1">
                        <span style="color: #f00;">{{ scope.row.check_user.split("&")[0] }}</span>
                        &nbsp;
                        <span>{{ scope.row.check_time.split(" ")[0] }}</span>
                        &nbsp;
                        <el-popover placement="left" trigger="hover" :content="scope.row.check_remark">
                          <span slot="reference"
                            style="color: var(--theme-color-customized-1); cursor: pointer;white-space: nowrap;">{{ $t('review.Check') }}</span>
                        </el-popover>
                      </div>
                      <!-- <img
                        class="icon"
                        src="@imgpub/public_preview.png"
                        v-if="scope.row.is_edit === 0"
                        @click="TheProgramDetails (scope.$index, scope.row)"
                        alt
                      />-->
                    <!-- </div> -->
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </template>
          <template slot="down">
            <pagination :current="current" :limit="limit" @currentChange="currentChange"></pagination>
          </template>
        </enfold-ucd>
      </template>
    </subfield>
    <!-- 审核弹窗 -->
    <form-dialog :title="$t('review.ProgramReview')" dWidth="800px" :dialogVisible="checkDv" @closeDialog="checkDc">
      <div class="msg-p-check">
        <div class="check-tab flex-c-c">
          <el-button size="mini" @click="actionTab = 'material'">{{ $t('review.ProgramMaterial') }}</el-button>
          <el-button size="mini" @click="actionTab = 'preview'">{{ $t('review.ProgramPreview') }}</el-button>
        </div>
        <div class="check-content">
          <div class="material-list" v-show="actionTab === 'material'">
            <program-material :vdrList="vdrList" @handlePreview="handlePreview"></program-material>
          </div>
          <div class="preview-list" v-if="actionTab === 'preview'">
            <program-preview :screenParam="screenParam" :vdrList="vdrList"></program-preview>
          </div>
          <div class="flex-c-c content-c">
            <el-input type="text" size="small" autosize :placeholder="$t('review.ReviewContent')"
              v-model="checkContent"></el-input>
            <el-button type="success" size="small" round style="margin-left: 10px;"
              @click="passCheck">{{ $t('review.Approved') }}</el-button>
            <el-button type="danger" size="small" round @click="rejectCheck">{{ $t('review.RejectReview') }}</el-button>
          </div>
        </div>
      </div>
    </form-dialog>
    <preview :previewData="previewData" @previewVisible="previewVisible"></preview>
    <msg-dialog :title="$t('review.ProgramReview')" :dialogVisible="checkAllDialogVisible"
      @closeDialog="checkAllCloseDialog" :buttonName="[$t('review.Approved'), $t('review.RejectReview')]">
      <div style="text-align:center;height: 60px;line-height: 60px">{{ $t('crp2') }}?</div>
      <el-input type="text" size="small" autosize :placeholder="$t('review.ReviewContent')"
        v-model="checkContent"></el-input>
    </msg-dialog>
    <del-dialog title="删除" :dialogVisible="delDialogVisible" @closeDialog="delCloseDialog">
      <div style="text-align:center;height: 60px;line-height: 60px">{{ $t('crp3') }}?</div>
    </del-dialog>
  </div>
</template>

<script>
import subfield from '@/components/basics/Subfield'
import EnfoldUcd from '@/components/basics/EnfoldUCD'
import trees from '@/components/basics/Trees'
import {
  mPagination,
  mPreview
} from "@/components/basics/mixins"
import pagination from '@/components/basics/Pagination'
import FormDialog from '@/components/basics/FormDialog'
import ProgramMaterial from './children/ProgramMaterial.vue'
import ProgramPreview from './children/ProgramPreview.vue'
import Preview from '@/components/basics/Preview'
import MsgDialog from "@/components/basics/MsgDialog"
import DelDialog from "@/components/basics/DelDialog"
export default {
  name: 'ProgramCheck',
  mixins: [mPagination, mPreview],
  data() {
    return {
      loading: false,
      groupList: [],
      programList: [],
      checkDv: false,
      programData: null,
      checkAllDialogVisible: false,
      delDialogVisible: false,
      seleted_list: [],
      actionTab: "material",
      checkContent: "",
      vdrList: [],
      select_data: '0,1,2',
      options: [{
        value: '0,1,2',
        label: 'review.all'
      }, {
        value: '0',
        label: 'review.waitReview'
      }, {
        value: '1',
        label: 'review.reject'
      }, {
        value: '2',
        label: 'review.approves'
      }],
      screenParam: {
        type: 'look', //add/look/edit/copy
        name: '',
        groupId: '',
        resolution: '',
        id: '',
        w: '',
        h: ''
      }
    }
  },
  created() {
    this.$http.post("/admin/access/groupList", {}, data => {
      this.groupList = data;
    });
    this.getProgramList();
  },
  methods: {
    rejectCheck() {
      if (this.checkContent === "") {
        this.$msg({
          message: this.$t('review.ReasonRefusal'),
          type: "warning",
          showClose: true
        });
        return;
      }
      this.checkPlay({
        check_result: 1,
        play_ids: this.programData.id,
        remark: this.checkContent,
        group_ids: sessionStorage.getItem('group_ids')
      });
      this.checkDc();
    },
    getRowKey(row) {
      return row.id;
    },
    selectionLineChangeHandle(val) {
      this.seleted_list = val;
    },
    checkAll() {
      if (this.seleted_list.length === 0) {
        this.$msg({ type: 'warning', message: this.$t('crp4') })
      } else {
        // console.log(this.seleted_list);
        this.checkAllDialogVisible = true;
      }
    },
    checkAllCloseDialog(isConfirm) {
      if (isConfirm === true || isConfirm === false) {
        let ids = this.seleted_list.map(ele => ele.id);

        if (this.checkContent === "" && isConfirm === false) {
          this.$msg({ message: this.$t('review.ReasonRefusal'), type: "warning", showClose: true });
          console.log(11);
          return;
        }
        this.checkPlay({
          check_result: isConfirm ? 2 : 1,
          play_ids: ids.toString(),
          remark: this.checkContent,
          group_ids: sessionStorage.getItem('group_ids')
        });
      }
      this.checkAllDialogVisible = false;
      this.$refs.multipleTable.clearSelection();
    },
    mulDelete() {
      if (this.seleted_list.length === 0) {
        this.$msg({
          type: 'warning',
          message: this.$t('review.selectTips1')
        })
      } else {
        //console.log(this.seleted_list)
        this.delDialogVisible = true;
      }
    },
    delCloseDialog(isConfirm) {
      // if (isConfirm === true) {
      //   let ids = this.seleted_list.map(ele => ele.id);

      //   if (this.checkContent === "" && isConfirm === false) {
      //     this.$msg({ message: this.$t('review.ReasonRefusal'), type: "warning", showClose: true });
      //     console.log(11);
      //     return;
      //   }
      // }

      if (isConfirm) {
        let ids = [];

        this.seleted_list.forEach(ele => {
          (ele.play_state !== 0) && ids.push(ele.id);
        });

        this.$refs.multipleTable.clearSelection();

        if (ids.length === 0) {
          this.$msg({ type: 'warning', message: this.$t('crp5') });
          return;
        }

        this.$http.post("/admin/check/checkPlayDel", { pids: ids.toString() }, (res) => {
          this.$msg({ type: 'success', message: this.$t('crp6') });
          res > 0 && this.getProgramList();
        });
      }
      this.delDialogVisible = false;
    },
    async passCheck() {
      await this.checkPlay({
        check_result: 2,
        play_ids: this.programData.id,
        remark: this.checkContent,
        group_ids: sessionStorage.getItem('group_ids')
      });
      await this.checkDc();
    },
    async checkPlay(params) {
      await this.$http.post("/admin/check/checkPlay", params, () => {
        this.getProgramList();
      });
    },
    checkDc() {
      this.checkDv = false;
      this.checkContent = "";
      this.actionTab = "material";
    },
    programCheck(index, row) {
      this.programData = row;
      let wh = row.size_remark.split("x");
      this.screenParam.name = row.name;
      this.screenParam.groupId = row.group_id;
      this.screenParam.resolution = row.size_remark;
      this.screenParam.id = row.id;
      this.screenParam.w = wh[0];
      this.screenParam.h = wh[1];
      this.$http.post("/admin/play/detail", {
        play_id: this.screenParam.id
      }, data => {
        this.vdrList = data.object_json;
      });
      this.checkDv = true;
    },


    getAssets(ids) {
      if (ids.type === "GROUP") {
        this.groupId = ids.id;
        this.groupIds = ids.ids;
        this.page = 1;
        this.current = 0;
        this.programList = [];
      }
      ids.id && this.getProgramList();
    },
    search(keyword) {
      this.keyword = keyword;
      this.getProgramList();
    },
    changeSelect(val) {
      // console.log(val)
      this.getProgramList({
        group_id: this.groupId,
        limit: this.limit,
        page: this.page,
        key_word: this.keyword,
        play_state: val
      });
    },
    currentChange(val) {
      this.page = val;
      this.getProgramList();
    },
    getProgramList(args = {
      group_id: this.groupId,
      limit: this.limit,
      page: this.page,
      key_word: this.keyword
    }) {
      this.loading = true;
      return this.$http.post("/admin/check/checkPlayList", args, data => {
        this.programList = data.data ? data.data : [];
        this.current = data.count ? parseInt(data.count) : 0;
        this.loading = false;
      });
    },
  },
  components: {
    subfield,
    trees,
    EnfoldUcd,
    pagination,
    FormDialog,
    ProgramMaterial,
    ProgramPreview,
    Preview,
    MsgDialog,
    DelDialog
  }
}
</script>

<style lang="scss" scoped>
.program-check {
  width: 100%;
  height: 100%;

  .icon {
    width: 30px;
    height: 30px;

    img {
      width: 30px;
      height: 30px;
    }
  }

  .c-u-right {
    // display: flex;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .select {
      margin-right: 28px;
    }

    .select /deep/ .el-input__inner {
      border-radius: 15px;
    }

    .search /deep/ .el-input__inner {
      border-radius: 15px;
    }

    // /deep/ .el-input__inner {
    //   height: 30px;
    //   line-height: 30px;
    //   border-radius: 15px;
    // }

    /deep/ .el-input__suffix {
      line-height: 30px;
      color: var(--theme-color-customized-1);
      font-size: 16px;
      right: 10px;
    }

    .icon {
      margin-right: 0px;
      margin-left: 25px;
    }
  }

  /deep/ .cell {
    font-size: 16px;
  }

  /deep/ .el-table__header-wrapper {
    .cell {
      font-size: 18px;
      color: var(--theme-color-customized-1);
    }

    th:last-child>.cell {
      text-align: center;
    }
  }

  .check-btn {
    // color: var(--theme-color-customized-1);
    cursor: pointer;
    user-select: none;

    &:hover {
      color: #000;
    }

    &:active {
      color: #ccc;
    }
  }

  .operation {
    display: flex;
    justify-content: space-around;
    align-items: center;

    .icon {
      margin: 0px;
    }
  }

  .icon {
    width: 30px;
    height: 30px;
    margin-right: 25px;
  }

  .filter {
    padding-left: 12px;

    .title {
      text-align: center;
      font-size: 16px;
      color: var(--theme-color-customized-1);
    }

    .title~.title {
      padding-top: 8px;
    }

    .content {
      padding-top: 8px;
    }
  }

  /deep/ .el-dialog__body {
    padding-top: 8px;
  }

  .msg-p-check {
    height: 420px;
    display: flex;
    flex-direction: column;

    .check-tab {
      flex: 0 0 30px;
      font-size: 16px;
      padding-bottom: 6px;
      border-bottom: 1px solid #d7ecf3;
      // .tab-content {
      //   margin: 0px 32px;
      // }
    }

    .check-content {
      height: calc(100% - 38px);
      display: flex;
      flex-direction: column;

      .material-list,
      .preview-list {
        height: calc(100% - 46px);
        background-color: #fff;
        margin-top: 6px;
        margin-bottom: 6px;
      }

      .content-c {
        flex: 0 0 34px;
      }
    }
  }

  /deep/ .el-table__header-wrapper {
    .cell {
      font-size: 18px;
      color: var(--theme-color-customized-1);
    }

    th:last-child>.cell {
      text-align: center;
    }
  }
}
</style>
